import { CustomCellRendererProps } from "ag-grid-react";
import { DECIMAL_2 } from "presentation/utils/numberUtil";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { CollectionConstant } from "./CollectionConstant";
import { CollectionDropdownOptions } from "presentation/model/Collection/CollectionModel";

const SCREEN_CONSTANT = CollectionConstant;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_COLLECTION_DTL_EDIT_COL_DEF = (dynamicOptions: CollectionDropdownOptions) => {
    return [
        {
            headerName: SCREEN_CONSTANT.PAYMENT_MODE,
            field: "paymentMode",
            enableRowGroup: true,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: "select",
            options: dynamicOptions.paymentModeDropdownOptions,
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.BANK_CODE,
            field: "bankCode",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: "select",
            options: dynamicOptions.bankCodeDropdownOptions,
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.PAY_ORDER_NO,
            field: "payOrderNo",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.AGENT_NAME,
            field: "agentName",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.PO_EXCESS_AMOUNT,
            field: "poExcessAmount",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: DECIMAL_2,
            cellStyle: { textAlign: 'right' },
        },
        {
            headerName: SCREEN_CONSTANT.PAY_ORDER_AMOUNT,
            field: "payOrderAmount",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            // dataType: "number",
            cellStyle: { textAlign: 'right' },
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.PAYMENT_AMOUNT,
            field: "paymentAmount",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: DECIMAL_2,
            cellStyle: { textAlign: 'right' },
        },
        {
            headerName: SCREEN_CONSTANT.BALANCE,
            field: "balance",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: DECIMAL_2,
            cellStyle: { textAlign: 'right' },
        },
        {
            headerName: SCREEN_CONSTANT.PAYEE,
            field: "payee",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            dataType: "select",
            options: dynamicOptions.payeeDropdownOptions,
            editable: true
        },
        {
            headerName: SCREEN_CONSTANT.PAYEE_NAME,
            field: "payeeName",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
        },
        {
            headerName: SCREEN_CONSTANT.REMARK,
            field: "remark",
            enableRowGroup: false,
            enablePivot: true,
            enableValue: false,
            rowGroup: false,
            filter: true,
            width: 200,
            editable: true
        },
    ].map((col, index) => {
        const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};
        return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
    });
};

export const INITIAL_COLLECTION_DTL_COL_DEF_OTHER: any[] = [
    {
        headerName: SCREEN_CONSTANT.DRAFT_INVOICE_NO,
        field: "invoiceNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: SCREEN_CONSTANT.PAYMENT_MODE,
        field: "paymentMode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PAY_ORDER_NO,
        field: "payOrderNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_NO,
        field: "agentNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_NAME,
        field: "agentName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PAYEE_NAME,
        field: "payeeName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.BANK_CODE,
        field: "bankCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PAY_ORDER_AMOUNT,
        field: "payOrderAmount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.PAYMENT_AMOUNT,
        field: "paymentAmount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: SCREEN_CONSTANT.REMARK,
        field: "remark",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.PORTAL_PAYMENT_MODE,
        field: "actualPaymentMode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}

